<app-card [title]="'database.basicInfo.title'" titleSize="large">
    <ng-template #content>
        <div [formGroup]="form" class="input-grid input-grid-gaps mb-4">
            @if (!hideLogo()) {
                <div class="flex flex-row mr-4">
                    <span class="mr-4">{{ 'inputs.logo' | translate }}:</span>
                    <app-input-logo
                        [owner]="'center_'+(center()?.id || '0')"
                        [imageUrl]="center()?.logo || ''"
                        (uploaded)="onFileUpload($event)"
                    ></app-input-logo>
                </div>
            }

            <app-date-input id="validFrom" [form]="form" class="align-self-end"></app-date-input>
            <div class="fr-3"></div>
            <!-- row -->
            <app-text-input id="name" [form]="form" class="fr-2"></app-text-input>
            <app-text-input id="ico" [form]="form"></app-text-input>
            <app-text-input id="dic" [form]="form"></app-text-input>
            <app-web-input [form]="form"></app-web-input>
            <!-- row -->
            <app-phone-input [form]="form"></app-phone-input>
            <app-email-input [form]="form" class="fr-2"></app-email-input>
            <app-date-input
                id="systemFrom"
                [disabled]="!store.isAllowedGlobal('organization.update')()"
                [form]="form"
            ></app-date-input>
            <app-date-input
                id="systemTo"
                [disabled]="!store.isAllowedGlobal('organization.update')()" [form]="form"
                class="align-self-end"
            ></app-date-input>
        </div>

        @if (isAllowed['organization.update']()) {
            <div class="flex gap justify-content-end">
                @if (form.dirty && currentInfo) {
                    <app-save-button
                        severity="secondary"
                        label="organization.updateInfo"
                        (clickEvent)="updateInfo()"
                    ></app-save-button>
                }

                <app-button
                    icon="pi-plus"
                    label="organization.createNewInfo"
                    (clickEvent)="createInfo()"
                ></app-button>
            </div>
        }

        @if (!hideTable()) {
            <p-divider></p-divider>

            <app-table
                translatePrefix="organization.administrationPage.basicInfos."
                [showDetail]="true"
                [hideCheckboxes]="true"
                (detailCallback)="changeEditTarget($event)"
                [showDelete]="isAllowed['organization.update']()"
                [items]="center()?.basicInfos || []"
                [columns]="columns"
                (deleteCallback)="deleteInfo($event)"
            ></app-table>
        }
    </ng-template>
</app-card>
